<div class="rounded-xl border border-gray-5 p-6 shadow">
  @if (title()) {
    <h2 class="mb-6 text-xl font-semibold">
      {{ title() }}
    </h2>
  }

  <div class="grid grid-cols-1 gap-8 md:grid-cols-[minmax(0,1fr)_min-content_minmax(0,1fr)]">
    <!-- LEFT COLUMN -->
    <div class="space-y-4 break-words">
      @for (item of sections()[0]; track item.label) {
        <div class="flex flex-col">
          <span class="text-sm font-bold">{{ item.label }}</span>

          <span>
            @if (item.pipe) {
              {{ item.pipe.transform(item.value) }}
            } @else {
              {{ item.value }}
            }
          </span>
        </div>
      }
    </div>

    <!-- SEPARATOR -->
    <div class="hidden w-px bg-gray-5 md:block"></div>

    <!-- RIGHT COLUMN -->
    <div class="space-y-4 break-words">
      @for (item of sections()[1]; track item.label) {
        <div class="flex flex-col">
          <span class="text-sm font-bold">{{ item.label }}</span>

          <span>
            @if (item.pipe) {
              {{ item.pipe.transform(item.value) }}
            } @else {
              {{ item.value }}
            }
          </span>
        </div>
      }
    </div>
  </div>
  <div class="pt-4">
    <ng-content></ng-content>
  </div>
</div>
